// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._vehiclesCatalog_2uz3a_1 {
  height: 100%;
  width: 100%;
}
._vehiclesCatalog__buttonCol_2uz3a_5 {
  margin-top: var(--perxis-auto-gap-vertical-yellow-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
